import { t } from "@lingui/macro";

import { HelpIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { useFlags } from "../../../utils/launchDarkly";

export const AddPlayersShareDisclaimer = () => {
  const { patronJoinBookingFlow } = useFlags();
  return patronJoinBookingFlow ? (
    <VStack
      py={6}
      px={2}
      bg="surface-secondary"
      borderRadius="2"
      gap={2}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        bg="surface-primary"
        width={40}
        height={40}
        borderRadius="6"
        alignItems="center"
        justifyContent="center"
      >
        <HelpIcon />
      </Box>
      <Text
        variant="mainBaseSemiBold"
        textAlign="center"
      >{t`Can’t find the person you’re looking for?`}</Text>
      <Text
        variant="mainBaseMedium"
        color="text-secondary"
        textAlign="center"
      >{t`No problem! You can share the booking with them afterward, and they’ll appear here next time.`}</Text>
    </VStack>
  ) : null;
};
